import { ClipboardIcon } from '../icons'
import { Stack, Typography, useTheme } from '@mui/material'
import React, { FC } from 'react'

interface FoundationDescriptionProps {
  description: string
}

export const FoundationDescription: FC<FoundationDescriptionProps> = ({ description }) => {
  const theme = useTheme()

  return (
    <Stack gap=".3rem" my={3}>
      <Typography fontSize="0.875rem" fontWeight={500} color="secondary.light">
        Program description
      </Typography>

      {description && (
        <Typography variant="body1" fontWeight={500} fontSize="0.875rem" color="secondary.main">
          {description}
        </Typography>
      )}

      {!description && (
        <Stack
          gap="0.2rem"
          height="150px"
          borderRadius="8px"
          alignItems="center"
          justifyContent="center"
          border={`1px solid ${theme.palette.grey[100]}`}
        >
          <ClipboardIcon sx={{ fontSize: '3rem' }} />

          <Typography fontWeight={500} fontSize="0.875rem" color="secondary.main">
            No description
          </Typography>
        </Stack>
      )}
    </Stack>
  )
}
